
import Facade from "../../UIFacade";
import * as PIXI from "pixi.js";
import LocalizedPIXIText from "@localisation/LocalizedPIXIText";
import BaseButtonComponent from "@baseUI/component/button/BaseButtonComponent";
import {buttonTextureCache} from "@baseUI/component/button/ButtonTexturesCache";

export default class ButtonDrawComponent extends BaseButtonComponent {
  constructor(settings= {width : 180, height: 100}) {
    super()
    this.settings = settings
    this.initialize()
  }

  initialize() {
      const listTextures = {};

      const cache = buttonTextureCache;
      const colorUp = 0x333333;
      const colorDown = 0x666666;
      const colorOver = 0x555555;
      const colorDisable = 0xcccccc;
      const {width, height} = this.settings;

      listTextures.up = cache.getButtonTexture({color: colorUp, width, height})
      listTextures.down = cache.getButtonTexture({color: colorDown, width, height})
      listTextures.over = cache.getButtonTexture({color: colorOver, width, height})
      listTextures.disable = cache.getButtonTexture({color: colorDisable, width, height})

      this.state = 'up'
      super.init(listTextures)
  }

  addText(text, style){
    let s = new PIXI.TextStyle(Facade.styles.styles[style])
    let pt = new LocalizedPIXIText(text, s)
    pt.anchor.set(0.5)
    this.button.addChild(pt);
  }

    set buttonSetStateTexture (state)  {
      this.state = state
      switch ( state ){
          case 'up':
              this.button.texture = this.textures.up
              break
          case 'over':
              this.button.texture = this.textures.over
              break
          case 'down':
              this.button.texture = this.textures.down

              break
      }

    }

    reset() {
      this.state = 'up'
      super.onButtonOut()
    }

    onButtonOver (e)  {
        if (this.state === 'down'){
            return
        }
        this.state = 'over'
        super.onButtonOver (e)
    }

    onButtonOut (e)  {
        if (this.state === 'down'){
            return
        }
        this.state = 'out'
        super.onButtonOut (e)
    }

    onButtonDown (e) {
        if (this.state === 'down'){
            this.onButtonUp (e)
        }
        this.state = 'down'
        super.onButtonDown (e)
    }

    onButtonUp (e) {
        e.stopPropagation()
        if(this.disabled || this.disabledManually) {return}
        if(this.isOut) {
            this.button.texture = this.textures.over
        } else {
           // this.button.texture = this.textures.up
            this.emit('tapButton')
        }
    }
}
